import * as _actions from './actions';
import _reducer from './reducer';
import _ProgressReport from './model';

_ProgressReport.actions = _actions;

export const actions = _actions;
export const reducer = _reducer;
export const ProgressReport = _ProgressReport;



// WEBPACK FOOTER //
// ./data/ProgressReports/index.js